import { useQuery } from '@tanstack/react-query';
import { companyService } from '../services/companyService';
import { useCompanies } from './useCompanies';

/**
 * Hook for fetching branch offices
 * Requires a company to be selected
 */
export function useBranchOffices() {
  const { selectedCompany } = useCompanies();

  console.log('🏢 useBranchOffices - selectedCompany:', selectedCompany);

  return useQuery({
    queryKey: ['branchOffices', selectedCompany?.id],
    queryFn: companyService.getBranchOffices,
    enabled: !!selectedCompany, // Solo ejecutar si hay compañía seleccionada
    staleTime: 0, // Always fresh - important for multi-company users
    gcTime: 1 * 60 * 1000, // Keep in cache for 1 minute
  });
}
